if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    resolveShippingOrigin() {
      const shippingGroup = this.querySelector('[data-shipping-origin]');
      const variantsElement = this.querySelector('[data-shipping-variants]');
      if (!shippingGroup || !variantsElement) return;

      let variants;
      try {
        variants = JSON.parse(variantsElement.textContent);
      } catch {
        return;
      }

      const shippingIndex = Number(this.dataset.shippingOptionPosition) - 1;
      if (shippingIndex < 0 || !Array.isArray(variants)) return;
      const selected = [];
      const groups = this.querySelectorAll(':scope > .m-product-option[data-option-position]');
      for (const group of groups) {
        const field = group.querySelector('select, input[type="radio"]:checked');
        const value = field?.selectedOptions
          ? Array.from(field.selectedOptions).find((option) => !option.disabled)?.value
          : field?.value;
        const index = Number(group.dataset.optionPosition) - 1;
        if (index !== shippingIndex && value === undefined) return;
        selected[index] = value;
      }

      const matches = variants.filter((variant) =>
        Array.isArray(variant.options) && variant.options.every((value, index) =>
          index === shippingIndex || value === selected[index]
        )
      );
      const currentOrigin = selected[shippingIndex];
      const isUnitedStates = (value) => ['unitedstates', 'us', 'usa'].includes(String(value).toLowerCase().replace(/[^a-z]/g, ''));
      const variant = matches.find((item) => item.available && isUnitedStates(item.options[shippingIndex]))
        || matches.find((item) => item.available && item.options[shippingIndex] === currentOrigin)
        || matches.find((item) => item.available)
        || matches.find((item) => item.options[shippingIndex] === currentOrigin)
        || matches[0];
      if (!variant) return;

      const origin = variant.options[shippingIndex];
      const select = shippingGroup.querySelector('select');
      if (select) {
        select.value = origin;
      } else {
        shippingGroup.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === origin;
        });
      }
      const inner = shippingGroup.querySelector('[data-picker-field]');
      if (inner) inner.dataset.selectedValue = origin;
      return origin !== currentOrigin ? variant : undefined;
    }

    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        const variant = this.resolveShippingOrigin();
        if (!variant) return;
        const field = this.querySelector('[data-shipping-origin] select, [data-shipping-origin] input:checked');
        if (!field) return;
        const productInfo = this.closest('product-info');
        productInfo?.toggleAddButton(true, window.MinimogStrings.addToCart, false);
        productInfo?.updateVariantInputs(variant.id);
        field.dispatchEvent(new Event('change', { bubbles: true }));
      });
      this.addEventListener('change', (event) => {
        this.resolveShippingOrigin();
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}